import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppSelector } from 'store';

import { getUserProfileStats } from '../queries';
import { profileConst } from '..';

export const useUserProfileStats = () => {
  const { query } = useRouter();
  const userId = query?.id as string | undefined;
  const isAuthenticated = useAppSelector(({ authModal }) => authModal.isAuthenticated.status);

  return useQuery({
    queryKey: [profileConst.queryKeys.USER_PROFILE_STATS, userId || 'self'],
    queryFn: getUserProfileStats(userId),
    enabled: isAuthenticated
  });
};
